import index from './pages/index'

const routes = [
    {
        path: '/core',
        name: 'Core',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/core/routes.js